/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Max_GuestsInputs */

const en_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max Guests`)
};

const es_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de invitados`)
};

const fr_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max d'invités`)
};

const de_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max. Gäste`)
};

const ja_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大宿泊人数`)
};

const zh_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最多可住宾客`)
};

const ar_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أقصى عدد للضيوف`)
};

const id_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tamu Maksimal`)
};

const it_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ospiti Massimi`)
};

const ru_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимум гостей`)
};

const pt_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Máximo de Hóspedes`)
};

const ko_field_max_guests = /** @type {(inputs: Field_Max_GuestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최대 인원`)
};

/**
* | output |
* | --- |
* | "Max Guests" |
*
* @param {Field_Max_GuestsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_max_guests = /** @type {((inputs?: Field_Max_GuestsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Max_GuestsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_max_guests(inputs)
	if (locale === "es") return es_field_max_guests(inputs)
	if (locale === "fr") return fr_field_max_guests(inputs)
	if (locale === "de") return de_field_max_guests(inputs)
	if (locale === "ja") return ja_field_max_guests(inputs)
	if (locale === "zh") return zh_field_max_guests(inputs)
	if (locale === "ar") return ar_field_max_guests(inputs)
	if (locale === "id") return id_field_max_guests(inputs)
	if (locale === "it") return it_field_max_guests(inputs)
	if (locale === "ru") return ru_field_max_guests(inputs)
	if (locale === "pt") return pt_field_max_guests(inputs)
	return ko_field_max_guests(inputs)
});